module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Hb-Ic.b950a4ba.png";